import { useState } from 'react';
import '../styles/pages/Products.css';
import useReveal from '../components/useReveal';
import PRODUCTS from '../data/products';

const FILTERS = [
  // { key: 'all',        label: 'All (21)' },
  // { key: 'antibiotic', label: 'Antibiotics' },
  // { key: 'antiinflam', label: 'Anti-Inflammatory' },
  // { key: 'fluoroquin', label: 'Fluoroquinolones' },
  // { key: 'cardio',     label: 'Cardiovascular' },
];

function Products({ navigate }) {
  useReveal();
  const [category, setCategory] = useState('all');
  const [search,   setSearch]   = useState('');

  const filtered = PRODUCTS.filter((p) => {
    const matchCat = category === 'all' || p.cat === category;
    const q        = search.toLowerCase();
    const matchQ   = p.name.toLowerCase().includes(q) || p.cas.includes(q);
    return matchCat && matchQ;
  });

  return (
    <>
      {/* Page hero */}
      <div className="page-hero">
        <div className="page-hero-bg"></div>
        <div className="page-hero-inner">
          <div className="eyebrow">Product Portfolio</div>
          <h1 className="headline">
            Active Pharmaceutical <em>Ingredients</em>
          </h1>
          <p>
            21 high-quality APIs manufactured to international pharmacopoeial standards.
            All products available with Drug Master File documentation for regulatory submissions.
          </p>
        </div>
      </div>

      {/* Products section */}
      <div className="products-page">
        <div className="products-page-inner">

          {/* Controls */}
          <div className="products-controls">
            <div className="search-bar">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" />
                <path d="M21 21l-4.35-4.35" />
              </svg>
              <input
                type="text"
                placeholder="Search by name or CAS number…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="filter-pills">
              {FILTERS.map((f) => (
                <button
                  key={f.key}
                  className={`fpill ${category === f.key ? 'on' : ''}`}
                  onClick={() => setCategory(f.key)}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </div>

          {/* Results count */}
          <div className="products-results-info">
            <strong>{filtered.length}</strong> products found
          </div>

          {/* Grid or empty state */}
          {filtered.length === 0 ? (
            <div className="no-results">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
              </svg>
              <h3>No products found</h3>
              <p>Try a different search term or filter</p>
            </div>
          ) : (
            <div className="product-grid">
              {filtered.map((p, i) => (
                <div
                  className={`prod-card reveal stagger-${(i % 4) + 1}`}
                  key={p.name}
                  onClick={() => navigate('contact')}
                >
                  <div className="prod-card-name">{p.name}</div>
                  <div className="prod-card-cas">CAS No. {p.cas}</div>
                  <div className="prod-card-tags">
                    {p.pharma.map((t) => <span className="ptag" key={t}>{t}</span>)}
                  </div>
                  <div className="prod-card-footer">
                    <div className={`dmf-status ${p.dmf === 'available' ? 'avail' : 'proc'}`}>
                      <div className="dot"></div>
                      DMF {p.dmf === 'available' ? 'Available' : 'Under Process'}
                    </div>
                    <div className="prod-card-arrow">Enquire →</div>
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </div>
    </>
  );
}

export default Products;
